import { render, staticRenderFns } from "./MainSearchBox.vue?vue&type=template&id=b77e193a&"
import script from "./MainSearchBox.vue?vue&type=script&lang=js&"
export * from "./MainSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports